/**
 * Karşılaştırma öncesi metin temizliği: baştaki/sondaki ve tekrar eden boşluklar.
 *
 * kod inceleme: bu gövde `genelIslemTakipFiltre.ts` (özel `metin`) ve
 * `excelDosyaCozumleme.ts` (`metinTemizle`) içinde birebir kopya olarak
 * duruyordu; tek kaynağa indirgendi. Modül BİLEREK bağımsız/saf tutuldu (Vue,
 * $uyap ya da store'a bağlı değil) — iki çağıran da bunu SAF kalmak için
 * tercih ediyor, ağır bootstrap zincirini (helper/router/store) sürüklemesin.
 */
export function metinTemizle(deger: any): string {
    if (deger === null || typeof deger === "undefined") return "";
    return String(deger).replace(/\s+/g, " ").trim();
}
